<template>
  <div class="manage-user">
    <div class="title">
      <h1 class="mt-4">Manage User</h1>
    </div>
    <div class="user-manager">
      <div class="top-header">
        <div class="search">
  <input class="search-bar" placeholder="Search Users" v-model="search" @input="handleFilterChange" />
  <div class="icon">
    <span class="mdi mdi-magnify" style="color: #000"></span>
  </div>
</div>


  <!-- Filter Dropdowns -->
  <div class="filters-container d-flex align-items-center gap-3">
    <div class="record-count"><strong>Records:</strong> {{ totalUsers }}</div>
    <div class="filter-group">
      <select class="form-select form-select-sm" v-model="selectedCountry" @change="handleFilterChange">
        <option value="">All Countries</option>
        <option v-for="country in uniqueCountries" :key="country" :value="country">{{ country }}</option>
      </select>
    </div>
    <div class="filter-group">
      <select class="form-select form-select-sm" v-model="selectedStatus" @change="handleFilterChange">
        <option value="">All Statuses</option>
        <option v-for="status in uniqueStatuses" :key="status" :value="status">{{ status }}</option>
      </select>
    </div>
    <div class="filter-group">
      <select class="form-select form-select-sm" v-model="selectedDepartment" @change="handleFilterChange">
        <option value="">All Departments</option>
        <option v-for="department in uniqueDepartments" :key="department" :value="department">{{ department }}</option>
      </select>
    </div>
  </div>

  <button class="btn btn-dark" v-if="permissions.includes('Create-User')" @click="createNewUser">Create User</button>
</div>

    </div>

    <!-- <div class="loader" v-if="loading"></div> -->

    <div class="manage-user-table">
      <table id="userTable" class="table table-striped table-bordered">
        <thead>
  <tr>
    <th @click="sortBy('employee_id')" class="column-name">
      <span>Employee ID</span>
      <span class="mdi mdi-swap-vertical sort-icon"></span>
    </th>
    <th @click="sortBy('name')" class="column-name">
      <span>Name</span>
      <span class="mdi mdi-swap-vertical sort-icon"></span>
    </th>
    <th @click="sortBy('country')" class="column-name">
      <span>Country</span>
      <span class="mdi mdi-swap-vertical sort-icon"></span>
    </th>
    <th @click="sortBy('department')" class="column-name">
      <span>Department</span>
      <span class="mdi mdi-swap-vertical sort-icon"></span>
    </th>
    <th @click="sortBy('status')" class="column-name">
      <span>Status</span>
      <span class="mdi mdi-swap-vertical sort-icon"></span>
    </th>
    <th v-if="permissions.includes('Edit-User')">Action</th>
  </tr>
</thead>

        <tbody v-if="loading">
  <tr>
    <td colspan="6" class="teamTableDesktop_processing text-center">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      Loading users...
    </td>
  </tr>
</tbody>
        <tbody v-else>
          <tr v-for="user in users" :key="user.employee_id">
            <td>{{ user.employee_id }}</td>
            <td>{{ user.name }}</td>
            <td>{{ user.country }}</td>
            <td>{{ user.department }}</td>
            <td>{{ user.status }}</td>
            <td style="cursor: pointer;">
              <div class="row d-flex justify-content-center">
                <div class="icon">
                  <span
                    class="mdi mdi-pencil edit"
                    @click="editUser(user.employee_id)"
                  ></span>
                </div>

                <!-- <div class="icon">
                  <span
                    class="mdi mdi-delete delete"
                    @click="openModel(item)"
                  ></span>
                </div> -->
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pop Up Modal -->
    <div v-if="myModel">
      <transition name="model">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" @click="myModel = false">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="confirmation pb-4" style="text-align: center">
                    <h4>Are you sure you want to delete this?</h4>
                  </div>
                  <div align="center">
                    <input
                      type="button"
                      class="btn btn-primary"
                      style="margin-right: 10px; width: 100px"
                      value="OK"
                      @click="deleteUser(modalData)"
                    />
                    <input
                      type="button"
                      class="btn btn-danger"
                      style="margin-left: 10px; width: 100px"
                      value="Cancel"
                      @click="myModel = false"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- Pagination Controls -->
    <div class="pagination-controls d-flex align-items-center justify-content-center gap-3">
      <button class="btn btn-outline-secondary" @click="prevPage" :disabled="currentPage === 1">Previous</button>
      <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
      <button class="btn btn-outline-secondary" @click="nextPage" :disabled="currentPage === totalPages">Next</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { routeNames } from '../js/routeNames';
import { decryptData } from '../js/utils/encrypt';
// import Swal from 'sweetalert2/dist/sweetalert2.js';

export default {
  components: {},
  props: {
    direction: String,
    sort: String,
  },
  data() {
    return {
      users: [],
      totalUsers: 0,
      loading: false,
      permissions: [],
      search: '',
      selectedCountry: '',
      selectedStatus: '',
      selectedDepartment: '',
      currentPage: 1,
      totalPages: 1,
      uniqueCountries: [], // Store API response directly
      uniqueDepartments: [],
      uniqueStatuses: [],
      sortField: 'country', // Default sort field
      sortDirection: 'asc', // Default sort direction
      

      //getAllStatus
    };
  },
  computed: {

  },
  mounted() {
    this.fetchCountries();
    this.fetchDepartments();
    this.fetchStatus();
    this.loadPermissions();
    this.fetchUsers();
  },
  methods: {
    async fetchCountries() {
      try {
        const response = await axios.get(this.$hostName + '/countries');
        this.uniqueCountries = response.data.map(item => item.location);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchDepartments() {
      try {
        const response = await axios.get(this.$hostName + '/getAllDepertments');
        this.uniqueDepartments = response.data.map(item => item.deparment);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchStatus() {
      try {
        const response = await axios.get(this.$hostName + '/getAllStatus');
        this.uniqueStatuses = response.data.map(item => item.status);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    loadPermissions() {
      let mkLocalData = localStorage.getItem('Permissions') || 'null';
      const secretPermissionKey = process.env.KEY || 'myscecretkey';
      this.permissions = decryptData(mkLocalData, secretPermissionKey);
    },
    // Sorting functions
  sortBy(column) {
    if (this.sortField === column) {
      // Toggle the sort direction if the column is already being sorted
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // Set the new column to sort by
      this.sortField = column;
      this.sortDirection = 'asc'; // Default to ascending if switching columns
    }
    this.fetchUsers(); // Re-fetch users with the new sort order
  },
  handleFilterChange() {
    this.fetchUsers(true); // Always reset page when filters change
  },
    fetchUsers(resetPage = false) {
      if (resetPage) {
      this.currentPage = 1; // Reset to first page when applying a new filter
    }

      this.loading = true;
      const params = {
        search: this.search,
        country: this.selectedCountry,
        department: this.selectedDepartment,
        status: this.selectedStatus,
        page: this.currentPage,

        sortField: this.sortField, // Include the sort field
        sortDirection: this.sortDirection, // Include the sort direction
      };

      axios.get(this.$hostName + '/getAllUsers', { params })
        .then(response => {
          this.users = response.
          data.data; // Laravel pagination sends data array

          this.users.forEach((user, index) => {
          user.sl_id = index + 1; // Adding serial ID (1-based index)
        });
          this.totalUsers = response.data.total;
          this.totalPages = response.data.last_page;
          if (this.currentPage > this.totalPages) {
          this.currentPage = 1; // If page is out of range, go back to the first page
          this.fetchUsers(); // Fetch users again with page 1
        }
        })
        .catch(error => console.error(error))
        .finally(() => this.loading = false);
    },
    createNewUser() {
      // this.$router.push({ name: routeNames.newUser });
      this.$router.push({
        name: routeNames.editEmployee,
        params: {
          empid: ''
        },
      });
    },
    editUser(item) {
      // console.log("checking emp id",item);
      this.$router.push({
        name: routeNames.editEmployee,
        params: {
          empid: item
        },
      });
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchUsers();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchUsers();
      }
    }
  },
};
</script>

<style scoped>
.title{
  margin-left: 4rem;
}
.manage-user {
  font-family: 'Montserrat', sans-serif;
  max-width: 100%;
  padding: 2rem;
  box-sizing: border-box;
}

.manage-user-table {
  overflow-x: auto;
  margin-left: 60px;
}

.table {
  width: 100%;
  table-layout: fixed; /* Ensures table cells do not stretch beyond their natural width */
}

.search-bar {
  width: 100%;
}

.filters-container {
  flex-wrap: wrap;
}

.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 768px) {
  .filters-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .filter-group {
    margin-bottom: 10px;
  }

  .top-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .btn {
    width: 100%;
    margin-top: 10px;
  }

  .manage-user-table table {
    font-size: 0.9rem;
  }

  .page-info {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .pagination-controls {
    flex-direction: column;
    gap: 10px;
  }
}
.top-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.search {
  flex: 1;
  max-width: 300px;
  margin-left: 80px;
}

.filters-container {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.filter-group select {
  width: 150px; /* Adjust size if necessary */
}

@media (max-width: 768px) {
  .top-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .search {
    width: 100%;
    margin-bottom: 10px;
  }

  .filters-container {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .filter-group {
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .btn {
    width: 100%;
    margin-top: 10px;
  }
}
.teamTableDesktop_processing {
  font-weight: bold;
  font-size: 16px;
  padding: 20px;
}

.search {
  display: flex;
  align-items: center;
  gap: 10px; /* Adjust spacing between input and icon */
  max-width: 300px;
  margin-left: 80px;
}

.search-bar {
  flex: 1;
  margin-top: -5px;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem; /* Adjust size if necessary */
}

.column-name{
  cursor: pointer;
}
</style>
